import { useLang } from 'hooks/lang';

import { Team } from 'entities';

import { Card, IconButton, Link, Table } from 'components/Blocks';
import { ArrowRightIcon } from 'components/Icons';

import { formatDate } from 'utils/date';

interface TeamsTableProps {
  teams: Team[];
  loading?: boolean;
}

export function TeamsTable({ teams, loading }: TeamsTableProps) {
  const { t } = useLang();

  return (
    <Card>
      <Table
        items={teams}
        loading={loading}
        itemsPerPage={15}
        uniqueKey="id"
        columns={[
          {
            label: t('name'),
            property: 'name',
            search: true,
            render: ({ name, id }) => (
              <Link to="teamProfile" params={{ teamId: id }} className="hover:underline">
                {name}
              </Link>
            ),
          },
          {
            label: t('created-at'),
            render: ({ createdAt }) => (createdAt ? formatDate(createdAt) : '-'),
            sort: true,
          },
          {
            render: ({ id }) => (
              <IconButton to="teamProfile" params={{ teamId: id }} className="ml-auto flex size-7">
                <ArrowRightIcon />
              </IconButton>
            ),
          },
        ]}
      />
    </Card>
  );
}
